import { Typography } from '@material-ui/core';
import { CalendarIcon } from 'components/Icons';
import { zonedTimeToUtc } from 'date-fns-tz';
import { DateFormats } from 'enuns/DateTypes';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getFormatedDateTime, TIME_ZONE_SP } from 'utils/DateUtils';
import useStyle from './style';




interface Props {
  date: Date;
  dateFim: Date;
  alignStart?: boolean;
}

export default function ({ date, dateFim, alignStart }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();

  const montarTextoHora = (data: Date): string => {
    return getFormatedDateTime(
      zonedTimeToUtc(data, TIME_ZONE_SP),
      DateFormats.Time
    ) as string;
 };

  const textoDia = useMemo(() => {
    const montarTexto = (data: Date): string => {
      return `${t(`AssembleiaDateTimeInicioEFim.weekday-${data.getDay()}`, {
        day: data.getDate(),
        month: t(`AssembleiaDateTimeInicioEFim.month-${data.getMonth()}`),
        year: data.getFullYear(),
      })} ${montarTextoHora(data)}`;
     };
    
    return `${montarTexto(date)} até ${montarTexto(dateFim)}`;
  }, [date, dateFim, t]);

  return (
    <time
      className={[classes.root, `${alignStart ? classes.alignStart : ''}`].join(' ').trim()}
      dateTime={date.toJSON()}
    >
      <CalendarIcon className={classes.icon} />
      <Typography className={classes.text} component="span">
        {textoDia}
      </Typography>
    </time>
  );
}
